import { CompanyAPI } from '@api';

const getCompanyBus = async (id) => CompanyAPI.getCompanyBus({ id })
  .then(({ data }) => data)
  .catch((error) => Promise.reject(error.response));

export { getCompanyBus };
